export function isEnum(value, check) {
    return ((typeof value === 'string' || typeof value === 'number') &&
        Object.values(check).includes(value));
}
export const toEnumError = `cannot be converted to enum.`;
/**
 * Converts a value to a key of an enum if found within the enum; otherwise throws an error.
 * @example
 * enum Foo {
 *   bar = 'bar',
 *   baz = 'baz',
 * }
 *
 * const someValue = 'bar';
 * const asEnum = toEnum(someValue, Foo); // typeof asEnum is Foo
 * const asFallback = toEnum('quux', Foo, Foo.bar); // typeof asEnum is Foo, and will be Foo.bar
 * const asError = toEnum('quux', Foo); // throws an error
 */
// TODO find a way to prevent `convertTo` from being a `string` literal or single member of the enum
export function toEnum(value, convertTo) {
    if (isEnum(value, convertTo))
        return value;
    throw new Error(`${String(value)}: ${toEnumError}`);
}
export const isNonNullable = (value) => value !== null && value !== undefined;
/**
 * For a `thing` ensures that values at the first level all exist; i.e. are not `undefined` or `null`.
 */
export function isNonNullableRecord(thing) {
    return Object.values(thing).every(isNonNullable);
}
export function isNullish(value) {
    return value === null || value === undefined;
}
/**
 * Truthy predicate to help TypeScript assure truthy values.
 * Often used with `filter`, but must be used directly, since the predicate return type won't propagate.
 * @example
 * const stuff = ['foo', 'bar', null]; // typeof stuff => (string | null)[]
 * // * used directly; satisfies TypeScript
 * const goodStuff = stuff.filter(isTruthy); // typeof goodStuff => string[]
 * // * used indirectly; TypeScript stays pessimistic
 * const indirectStuff = stuff.filter((thing) => isTruthy(thing)); // typeof indirectStuff => (string | null)[]
 */
export const isTruthy = (value) => !!value;
/** Verifies a given array has `length` equal to `minLength`, meaning it's a tuple of that minimum size. */
export function isTuple(value, minLength) {
    return value.length >= minLength;
}
/**
 * An abstraction of the built-in `Array.prototype.map` method, but acts more narrowly on `readonly` arrays; i.e. helping to assure they're still tuples.
 * Useful for proving a one-to-one mapping of a known tuple to another known tuple without needing to re-assert the tuple type from a programmatic `map` call.
 */
// ? might better be suited to `corso-utils/array.ts`, but would result in a cyclical dependency
export function mapped(items, callback) {
    return items.map(callback);
}
//# sourceMappingURL=typing.js.map